import { render, staticRenderFns } from "./BudgetFilterSection.vue?vue&type=template&id=3b0a570e&scoped=true&"
import script from "./BudgetFilterSection.vue?vue&type=script&lang=js&"
export * from "./BudgetFilterSection.vue?vue&type=script&lang=js&"
import style0 from "./BudgetFilterSection.vue?vue&type=style&index=0&id=3b0a570e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b0a570e",
  null
  
)

export default component.exports